<template>
  <div class="tags-pane">
    <div class="tags-title">tags</div>
    <div class="tags">
      <h5 v-for="(tag, key) in tags" :key="key" :class="[{ 'first' : key === 0 }]">
        <term-link v-if="tag.tid" :tid="tag.tid" :title="tag.title" :url="tag.relative_url" :type="tag.type">{{tag.title}}</term-link>
      </h5>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import map from 'lodash/map'
import last from 'lodash/last'
import concat from 'lodash/concat'
import forEach from 'lodash/forEach'

import TermLink from 'components/term/Link'

export default {
  name: 'tag',
  props: ['node', 'truncateLength'],
  components: {
    TermLink,
  },
  computed: {
    topics() {
      return map(get(this, 'node.topics', []), this.$store.getters.term)
    },
    sections() {
      const sections = []
      forEach(get(this, 'node.sections', []), (sectionLineage) => {
        const sectionList = map(sectionLineage, this.$store.getters.term)
        sections.push(sectionList)
      })
      return sections
    },
    tags() {
      const sectionTags = map(this.sections, lineage => last(lineage))
      return concat(this.topics, sectionTags)
    },
  },
}
</script>
<style lang="scss" scoped>
  .tags-title {
    @include respond-to('mobile') {
      display: inline-block;
      font-size: rem-calc(20);
      vertical-align: top;
    }
    color: $oxford-blue;
    font-weight: bold;
    font-size: rem-calc(24);
    line-height: rem-calc(24);
    text-transform: uppercase;
    display: inline;
  }
  .tags {
    @include respond-to('mobile') {
      display: inline-block;
      padding-left: rem-calc(16);
    }
    h5 {
      margin: rem-calc(0 8 0 0);
      text-transform: lowercase;
      display: inline-block;
      font-size: rem-calc(20);
      margin-top: rem-calc(16);

      @include respond-to('mobile') {
        font-size: rem-calc(18);
        margin-top: rem-calc(4);
      }
      &.first {
        display: block;
        font-size: rem-calc(30);
        line-height: rem-calc(28);
        margin-top: rem-calc(20);
        @include respond-to('mobile') {
          font-size: rem-calc(28);
          line-height: rem-calc(20);
          margin-top: 0;
        }
      }
      &:before {
        content: '#';
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Tag.vue?6eaac92f